import { render, staticRenderFns } from "./InsertTable.vue?vue&type=template&id=3c4628e9&scoped=true"
import script from "./InsertTable.js?vue&type=script&lang=js&external"
export * from "./InsertTable.js?vue&type=script&lang=js&external"
import style0 from "./InsertTable.scss?vue&type=style&index=0&id=3c4628e9&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c4628e9",
  null
  
)

export default component.exports